import type {
  TianGanInfo,
  DiZhiInfo,
  ShiShenDesc,
  GeJuInfo,
  DayMasterInfo,
  ChangShengInfo,
  ShenShaInfo,
  NaYinInfo,
  JianChuInfo,
  XiuInfo,
  ShiChenInfo,
  XiYongShen
} from '../types';

// 天干详细信息
export const TIANGAN_DETAIL: Record<string, TianGanInfo> = {
  '甲': {
    element: '木',
    yinYang: '阳',
    nature: '参天大树',
    desc: '甲木为参天大树，性格刚直、有领导力。甲木之人如大树一般，根基深厚，向上生长，有强大的生命力和领导才能。',
    characteristics: ['刚直不阿', '有领导才能', '有主见', '独立性强', '固执己见'],
    season: '春季当令',
    direction: '东方'
  },
  '乙': {
    element: '木',
    yinYang: '阴',
    nature: '花草藤蔓',
    desc: '乙木为花草藤蔓，性格柔和、善于变通。乙木之人如花草般柔韧，能够适应环境，善于借助外力成长。',
    characteristics: ['性格柔和', '善于变通', '适应力强', '善解人意', '缺乏主见'],
    season: '春季当令',
    direction: '东方'
  },
  '丙': {
    element: '火',
    yinYang: '阳',
    nature: '太阳之火',
    desc: '丙火为太阳之火，性格热情、光明磊落。丙火之人如太阳般温暖，能够照亮他人，有强烈的正义感和奉献精神。',
    characteristics: ['热情开朗', '光明磊落', '无私奉献', '有感染力', '容易急躁'],
    season: '夏季当令',
    direction: '南方'
  },
  '丁': {
    element: '火',
    yinYang: '阴',
    nature: '灯烛之火',
    desc: '丁火为灯烛之火，性格温和、心思细腻。丁火之人如灯火般温暖持久，有耐心，善于细节处理。',
    characteristics: ['温和细腻', '心思缜密', '持久稳定', '有耐心', '缺乏魄力'],
    season: '夏季当令',
    direction: '南方'
  },
  '戊': {
    element: '土',
    yinYang: '阳',
    nature: '城墙之土',
    desc: '戊土为城墙之土，性格稳重、诚实守信。戊土之人如城墙般厚重，能够承载万物，有强大的包容心和责任感。',
    characteristics: ['稳重可靠', '诚实守信', '包容万物', '踏实肯干', '过于保守'],
    season: '四季末',
    direction: '中央'
  },
  '己': {
    element: '土',
    yinYang: '阴',
    nature: '田园之土',
    desc: '己土为田园之土，性格包容、养育万物。己土之人如田园般肥沃，能够滋养万物，有温和的性格和养育之性。',
    characteristics: ['温和包容', '善于照顾', '养育万物', '心细如发', '过于软弱'],
    season: '四季末',
    direction: '中央'
  },
  '庚': {
    element: '金',
    yinYang: '阳',
    nature: '刀剑之金',
    desc: '庚金为刀剑之金，性格刚毅、果断决绝。庚金之人如刀剑般锋利，有强大的决断力和执行力，敢于面对挑战。',
    characteristics: ['刚毅果断', '有决断力', '锐意进取', '勇往直前', '过于冷酷'],
    season: '秋季当令',
    direction: '西方'
  },
  '辛': {
    element: '金',
    yinYang: '阴',
    nature: '首饰之金',
    desc: '辛金为首饰之金，性格精致、追求完美。辛金之人如首饰般精致，有艺术品味，注重细节和外表。',
    characteristics: ['精致完美', '有艺术品味', '注重细节', '心思细腻', '过于计较'],
    season: '秋季当令',
    direction: '西方'
  },
  '壬': {
    element: '水',
    yinYang: '阳',
    nature: '江河之水',
    desc: '壬水为江河之水，性格奔放、智慧深邃。壬水之人如江河般浩瀚，有深邃的智慧和奔放的个性，善于思考。',
    characteristics: ['奔放不羁', '智慧深邃', '善于思考', '随机应变', '过于随性'],
    season: '冬季当令',
    direction: '北方'
  },
  '癸': {
    element: '水',
    yinYang: '阴',
    nature: '雨露之水',
    desc: '癸水为雨露之水，性格含蓄、滋润万物。癸水之人如雨露般滋润，有含蓄的性格和深沉的智慧，善于滋润他人。',
    characteristics: ['含蓄内敛', '善于思考', '滋润万物', '智慧深沉', '过于消极'],
    season: '冬季当令',
    direction: '北方'
  }
};

// 地支详细信息
export const DIZHI_DETAIL: Record<string, DiZhiInfo> = {
  '子': {
    element: '水',
    yinYang: '阳',
    hidden: ['癸'],
    hiddenDesc: ['癸水为雨露之水，子水藏癸水，为纯水之气，代表纯粹的智慧与流动'],
    desc: '子水为阳水，藏癸水，为正北方位。子水代表冬季的智慧与收藏，有聪明机智、善于思考的特性。',
    characteristics: ['聪明机智', '善于思考', '行动力强', '变化多端', '独立自主'],
    zodiac: '鼠',
    month: '冬月（农历十一月）',
    direction: '正北',
    time: '23:00-01:00（子时）'
  },
  '丑': {
    element: '土',
    yinYang: '阴',
    hidden: ['己', '癸', '辛'],
    hiddenDesc: [
      '己土为本气，代表田园之土，主收藏与积蓄',
      '癸水为墓库水，代表隐藏的财源与智慧',
      '辛金为墓库金，代表隐藏的锐利与决断'
    ],
    desc: '丑土为湿土，是冬季之土，藏己土、癸水、辛金，为金之墓库。丑土之人稳重踏实，内敛深沉，善于积累。',
    characteristics: ['稳重踏实', '内敛深沉', '有收藏之性', '善于积累', '性格固执'],
    zodiac: '牛',
    month: '腊月（农历十二月）',
    direction: '东北偏北',
    time: '01:00-03:00（丑时）'
  },
  '寅': {
    element: '木',
    yinYang: '阳',
    hidden: ['甲', '丙', '戊'],
    hiddenDesc: [
      '甲木为本气，参天大树，主生发与成长',
      '丙火为长生之火，代表希望与活力',
      '戊土为堤岸之土，稳固木之根基'
    ],
    desc: '寅木为阳木，是春季之木，藏甲木、丙火、戊土，为火之长生地。寅木之人积极进取，充满活力，有领导才能。',
    characteristics: ['积极进取', '充满活力', '有领导才能', '勇于开拓', '性格急躁'],
    zodiac: '虎',
    month: '正月（农历一月）',
    direction: '东北偏东',
    time: '03:00-05:00（寅时）'
  },
  '卯': {
    element: '木',
    yinYang: '阴',
    hidden: ['乙'],
    hiddenDesc: ['乙木为花草藤蔓，卯木藏乙木，为纯木之气，代表柔和与生长'],
    desc: '卯木为阴木，藏乙木，为正东方位。卯木代表春季的柔和与生长，有温和、善于变通的特性。',
    characteristics: ['性格温和', '善于变通', '有艺术天赋', '适应力强', '缺乏主见'],
    zodiac: '兔',
    month: '二月（农历二月）',
    direction: '正东',
    time: '05:00-07:00（卯时）'
  },
  '辰': {
    element: '土',
    yinYang: '阳',
    hidden: ['戊', '乙', '癸'],
    hiddenDesc: [
      '戊土为本气，城墙之土，主稳固与管理',
      '乙木为余气，代表春季的残留生机',
      '癸水为墓库水，代表水库与收藏'
    ],
    desc: '辰土为湿土，是春季之土，藏戊土、乙木、癸水，为水之墓库。辰土之人稳重包容，有管理能力，善于变化。',
    characteristics: ['稳重包容', '有管理能力', '善于变化', '有收藏之性', '性格多变'],
    zodiac: '龙',
    month: '三月（农历三月）',
    direction: '东南偏东',
    time: '07:00-09:00（辰时）'
  },
  '巳': {
    element: '火',
    yinYang: '阴',
    hidden: ['丙', '庚', '戊'],
    hiddenDesc: [
      '丙火为本气，太阳之火，主光明与热情',
      '庚金为长生之金，代表锐利与决断',
      '戊土为堤岸之土，稳固火之根基'
    ],
    desc: '巳火为阴火，是夏季之火，藏丙火、庚金、戊土，为金之长生地。巳火之人热情洋溢，善于表达，有进取心。',
    characteristics: ['热情洋溢', '善于表达', '有进取心', '追求完美', '性格急躁'],
    zodiac: '蛇',
    month: '四月（农历四月）',
    direction: '东南偏南',
    time: '09:00-11:00（巳时）'
  },
  '午': {
    element: '火',
    yinYang: '阳',
    hidden: ['丁', '己'],
    hiddenDesc: [
      '丁火为本气，灯烛之火，主文明与智慧',
      '己土为田园之土，稳固火之根基'
    ],
    desc: '午火为阳火，藏丁火、己土，为正南方位。午火代表夏季的热情与光明，有领导才能，积极进取。',
    characteristics: ['热情开朗', '光明磊落', '有领导才能', '积极进取', '容易冲动'],
    zodiac: '马',
    month: '五月（农历五月）',
    direction: '正南',
    time: '11:00-13:00（午时）'
  },
  '未': {
    element: '土',
    yinYang: '阴',
    hidden: ['己', '丁', '乙'],
    hiddenDesc: [
      '己土为本气，田园之土，主养育与包容',
      '丁火为余气，代表夏季的残留热量',
      '乙木为墓库木，代表木之收藏'
    ],
    desc: '未土为燥土，是夏季之土，藏己土、丁火、乙木，为木之墓库。未土之人温和包容，善于养育，有艺术气质。',
    characteristics: ['温和包容', '善于养育', '有艺术气质', '心思细腻', '性格软弱'],
    zodiac: '羊',
    month: '六月（农历六月）',
    direction: '西南偏南',
    time: '13:00-15:00（未时）'
  },
  '申': {
    element: '金',
    yinYang: '阳',
    hidden: ['庚', '壬', '戊'],
    hiddenDesc: [
      '庚金为本气，刀剑之金，主锐利与决断',
      '壬水为长生之水，代表智慧与流动',
      '戊土为堤岸之土，稳固金之根基'
    ],
    desc: '申金为阳金，是秋季之金，藏庚金、壬水、戊土，为水之长生地。申金之人刚毅果断，聪明机智，善于分析。',
    characteristics: ['刚毅果断', '聪明机智', '善于分析', '有决断力', '性格冷酷'],
    zodiac: '猴',
    month: '七月（农历七月）',
    direction: '西南偏西',
    time: '15:00-17:00（申时）'
  },
  '酉': {
    element: '金',
    yinYang: '阴',
    hidden: ['辛'],
    hiddenDesc: ['辛金为首饰之金，酉金藏辛金，为纯金之气，代表精致与完美'],
    desc: '酉金为阴金，藏辛金，为正西方位。酉金代表秋季的精致与完美，有艺术品味，注重细节。',
    characteristics: ['精致完美', '注重细节', '有艺术品味', '心思细腻', '过于计较'],
    zodiac: '鸡',
    month: '八月（农历八月）',
    direction: '正西',
    time: '17:00-19:00（酉时）'
  },
  '戌': {
    element: '土',
    yinYang: '阳',
    hidden: ['戊', '辛', '丁'],
    hiddenDesc: [
      '戊土为本气，城墙之土，主稳固与守护',
      '辛金为余气，代表秋季的残留锐利',
      '丁火为墓库火，代表火之收藏'
    ],
    desc: '戌土为燥土，是秋季之土，藏戊土、辛金、丁火，为火之墓库。戌土之人稳重可靠，有责任感，忠诚守信。',
    characteristics: ['稳重可靠', '有责任感', '善于收藏', '忠诚守信', '性格固执'],
    zodiac: '狗',
    month: '九月（农历九月）',
    direction: '西北偏西',
    time: '19:00-21:00（戌时）'
  },
  '亥': {
    element: '水',
    yinYang: '阴',
    hidden: ['壬', '甲'],
    hiddenDesc: [
      '壬水为本气，江河之水，主流动与智慧',
      '甲木为长生之木，代表生发与希望'
    ],
    desc: '亥水为阴水，藏壬水、甲木，为木之长生地。亥水代表冬季的智慧与生发，有包容力，智慧深沉。',
    characteristics: ['智慧深沉', '善于思考', '有生发之性', '包容力强', '过于消极'],
    zodiac: '猪',
    month: '十月（农历十月）',
    direction: '西北偏北',
    time: '21:00-23:00（亥时）'
  }
};

// 纳音详细解读
export const NAYIN_DETAIL: Record<string, NaYinInfo> = {
  '海中金': {
    name: '海中金',
    element: '金',
    desc: '海底之金，深藏不露，需要挖掘才能发现其价值。如海底宝藏，潜力巨大但不易显露。',
    characteristics: ['深藏不露', '价值待发掘', '需要时机', '潜力巨大', '性格内敛', '有内涵'],
    fortune: '早年运势平平，如金藏于海，不易被发现。中年后逐渐显露才华，需要耐心等待时机，晚年富贵可期。适合从事需要深度积累的工作。'
  },
  '炉中火': {
    name: '炉中火',
    element: '火',
    desc: '炉火之火，需要木柴助燃，温暖而有节制。如家中炉火，温暖稳定但不猛烈。',
    characteristics: ['温暖有度', '需要助力', '性格稳重', '有节制', '善于规划', '持久稳定'],
    fortune: '一生温暖平安，但需要贵人相助如同炉火需要柴薪。中年后事业有成，适合从事稳定持续的工作，不宜急于求成。'
  },
  '大林木': {
    name: '大林木',
    element: '木',
    desc: '森林之木，茂盛繁密，有庇荫之功。如茂密森林，能够庇护万物生长。',
    characteristics: ['茂盛繁密', '庇荫他人', '领导才能', '根基稳固', '性格正直', '包容力强'],
    fortune: '一生顺利，如森林般茂盛。有领导才能，能够庇荫他人，成就大事。适合从事管理、教育等能够庇荫他人的工作。'
  },
  '路旁土': {
    name: '路旁土',
    element: '土',
    desc: '路边之土，养育万物，为人所用。如路边土地，默默养育行人草木。',
    characteristics: ['养育万物', '为人服务', '性格温和', '包容性强', '踏实肯干', '默默奉献'],
    fortune: '一生辛勤耕耘，如路边之土默默服务。能够服务他人，获得尊重。适合从事服务性行业，通过服务他人获得成功。'
  },
  '剑锋金': {
    name: '剑锋金',
    element: '金',
    desc: '刀剑之金，锋利无比，有决断之力。如宝剑出鞘，锋芒毕露。',
    characteristics: ['锋利无比', '决断果敢', '锐意进取', '敢于冒险', '性格刚强', '有魄力'],
    fortune: '一生有决断力，如剑锋般锐利。能够成就事业，但要注意控制脾气，避免过于锋利伤人。适合从事需要决断力的工作。'
  },
  '山头火': {
    name: '山头火',
    element: '火',
    desc: '山上之火，向上燃烧，有上升之势。如山顶烽火，高远明亮。',
    characteristics: ['向上燃烧', '积极进取', '有领导才能', '性格热情', '追求完美', '志向高远'],
    fortune: '一生向上进取，如火焰向上升腾。能够成就事业，但要注意身体健康，避免过度消耗。适合从事需要领导力的工作。'
  },
  '涧下水': {
    name: '涧下水',
    element: '水',
    desc: '山涧之水，清澈流动，有润泽之功。如山间清泉，清澈甘甜。',
    characteristics: ['清澈流动', '润泽万物', '性格温和', '善于变通', '心思细腻', '纯净透明'],
    fortune: '一生温和顺利，如涧水般清澈。能够润泽他人，获得好名声。适合从事教育、咨询等能够滋润他人的工作。'
  },
  '城头土': {
    name: '城头土',
    element: '土',
    desc: '城墙之土，厚重稳固，能够守护。如古老城墙，守护一方平安。',
    characteristics: ['厚重稳固', '守护之力', '性格稳重', '有责任感', '踏实可靠', '保护性强'],
    fortune: '一生稳重可靠，如城墙般坚固。能够守护家人，获得尊重。适合从事需要守护、保护性质的工作，如安保、管理等。'
  },
  '白蜡金': {
    name: '白蜡金',
    element: '金',
    desc: '白蜡之金，精致美丽，有装饰之功。如白蜡制品，精致优雅。',
    characteristics: ['精致美丽', '装饰之功', '性格细腻', '注重外表', '追求完美', '艺术气质'],
    fortune: '一生精致优雅，如白蜡般美丽。能够获得美好事物，但要注意内在修养，不可过于注重外表。适合从事艺术、设计等工作。'
  },
  '杨柳木': {
    name: '杨柳木',
    element: '木',
    desc: '杨柳之木，柔软多姿，随风而舞。如杨柳依依，柔美动人。',
    characteristics: ['柔软多姿', '善于变通', '性格温和', '适应力强', '善解人意', '柔美动人'],
    fortune: '一生温和顺利，如杨柳般柔韧。能够适应各种环境，获得幸福。适合从事需要适应性和沟通能力的工作。'
  },
  '泉中水': {
    name: '泉中水',
    element: '水',
    desc: '泉水之水，源源不断，有滋养之功。如山间清泉，源源不断。',
    characteristics: ['源源不断', '滋养之功', '性格温和', '善于思考', '心思细腻', '持久稳定'],
    fortune: '一生源源不断，如泉水般持久。能够滋养他人，获得财富。适合从事教育、医疗等能够持续滋养他人的工作。'
  },
  '屋上土': {
    name: '屋上土',
    element: '土',
    desc: '屋顶之土，遮风挡雨，有保护之功。如屋顶瓦片，遮风挡雨。',
    characteristics: ['遮风挡雨', '保护之功', '性格稳重', '有责任感', '踏实肯干', '守护家庭'],
    fortune: '一生能够保护家人，如屋顶般遮风挡雨。获得安稳生活，适合从事建筑、房地产等与房屋相关的工作。'
  },
  '霹雳火': {
    name: '霹雳火',
    element: '火',
    desc: '雷电之火，威力巨大，有震撼之功。如霹雳闪电，震撼人心。',
    characteristics: ['威力巨大', '震撼之功', '性格急躁', '敢于冒险', '充满激情', '爆发力强'],
    fortune: '一生充满激情，如霹雳般震撼。能够成就大事，但要注意控制脾气，避免冲动行事。适合从事需要爆发力的工作。'
  },
  '松柏木': {
    name: '松柏木',
    element: '木',
    desc: '松柏之木，四季常青，有坚韧之性。如松柏挺立，不畏严寒。',
    characteristics: ['四季常青', '坚韧不拔', '性格坚毅', '有耐力', '不畏艰难', '持久稳定'],
    fortune: '一生坚韧不拔，如松柏般常青。能够克服各种困难，获得成功。适合从事需要长期坚持的工作，终会获得成功。'
  },
  '长流水': {
    name: '长流水',
    element: '水',
    desc: '长河之水，奔流不息，有持久之功。如长江大河，奔流不息。',
    characteristics: ['奔流不息', '持久之功', '性格坚韧', '有耐心', '善于思考', '源远流长'],
    fortune: '一生持久稳定，如长河般奔流。能够积累财富，晚年富贵。适合从事需要长期积累的工作，如金融、科研等。'
  },
  '沙中金': {
    name: '沙中金',
    element: '金',
    desc: '沙中之金，需要淘洗才能发现。如沙里淘金，价值隐藏。',
    characteristics: ['需要淘洗', '价值隐藏', '性格内敛', '需要时机', '潜力巨大', '厚积薄发'],
    fortune: '早年运势平平，如金藏于沙。需要努力才能成功，中年后富贵。适合从事需要长期磨练才能显露才华的工作。'
  },
  '山下火': {
    name: '山下火',
    element: '火',
    desc: '山下之火，温暖有度，有节制之功。如山下篝火，温暖有度。',
    characteristics: ['温暖有度', '有节制', '性格稳重', '善于规划', '踏实肯干', '不急不躁'],
    fortune: '一生温暖平安，如山下之火稳定。能够稳定发展，获得成功。适合从事稳定持续的工作，不宜急于求成。'
  },
  '平地木': {
    name: '平地木',
    element: '木',
    desc: '平地之木，生长平稳，有安定之性。如平原树木，生长平稳。',
    characteristics: ['生长平稳', '安定之性', '性格平和', '踏实肯干', '不急不躁', '稳定发展'],
    fortune: '一生平稳安定，如平地般平稳。能够获得幸福，但要注意保持进取心。适合从事稳定性强的工作。'
  },
  '壁上土': {
    name: '壁上土',
    element: '土',
    desc: '墙壁之土，坚固耐用，有保护之功。如墙壁坚固，保护室内。',
    characteristics: ['坚固耐用', '保护之功', '性格稳重', '有责任感', '踏实可靠', '守护之力'],
    fortune: '一生稳重可靠，如墙壁般坚固。能够保护家人，获得尊重。适合从事建筑、防护等相关工作。'
  },
  '金箔金': {
    name: '金箔金',
    element: '金',
    desc: '金箔之金，薄而贵重，有装饰之功。如金箔装饰，贵重华丽。',
    characteristics: ['薄而贵重', '装饰之功', '性格精致', '注重外表', '追求完美', '华丽优雅'],
    fortune: '一生精致优雅，如金箔般华丽。能够获得美好事物，但要注意内在修养。适合从事艺术、装饰、奢侈品等相关工作。'
  },
  '覆灯火': {
    name: '覆灯火',
    element: '火',
    desc: '灯罩之火，光明温暖，有照亮之功。如灯罩灯火，温暖明亮。',
    characteristics: ['光明温暖', '照亮之功', '性格温和', '善于照顾', '心思细腻', '温暖人心'],
    fortune: '一生温暖平安，如灯火般照亮他人。能够获得好名声，适合从事教育、服务、医疗等能够照亮他人的工作。'
  },
  '天河水': {
    name: '天河水',
    element: '水',
    desc: '天河之水，浩瀚无垠，有包容之功。如银河般浩瀚，包容万物。',
    characteristics: ['浩瀚无垠', '包容万物', '性格宽广', '有气度', '智慧深邃', '气度恢宏'],
    fortune: '一生气度恢宏，如天河般浩瀚。能够包容万物，成就大事。适合从事管理、领导等需要大气度的工作。'
  },
  '大驿土': {
    name: '大驿土',
    element: '土',
    desc: '驿站之土，交通要道，有通达之功。如古驿站，通达四方。',
    characteristics: ['交通要道', '通达四方', '性格随和', '善于交际', '信息灵通', '人脉广泛'],
    fortune: '一生通达四方，如驿站般畅通。善于交际，能够获得各种机会。适合从事贸易、物流、公关等需要广泛人脉的工作。'
  },
  '钗钏金': {
    name: '钗钏金',
    element: '金',
    desc: '首饰之金，精致美丽，有装饰之功。如钗钏首饰，精致美丽。',
    characteristics: ['精致美丽', '装饰之功', '性格细腻', '注重外表', '追求完美', '优雅高贵'],
    fortune: '一生精致优雅，如钗钏般美丽。能够获得美好事物，但要注意实际。适合从事珠宝、时尚、艺术等相关工作。'
  },
  '桑柘木': {
    name: '桑柘木',
    element: '木',
    desc: '桑柘之木，可以养蚕，有实用之功。如桑树养蚕，实用价值高。',
    characteristics: ['实用之功', '养育之能', '性格务实', '善于经营', '勤劳肯干', '脚踏实地'],
    fortune: '一生务实勤劳，如桑柘般实用。能够经营家业，获得稳定收入。适合从事实业、农业、养殖等实际工作。'
  },
  '大溪水': {
    name: '大溪水',
    element: '水',
    desc: '大溪之水，流动不息，有滋润之功。如大溪流，滋润两岸。',
    characteristics: ['流动不息', '滋润之功', '性格温和', '善于变通', '心思细腻', '源远流长'],
    fortune: '一生温和顺利，如大溪般流动。能够滋润他人，获得财富。适合从事流通、贸易、教育等能够滋润他人的工作。'
  },
  '沙中土': {
    name: '沙中土',
    element: '土',
    desc: '沙中之土，松散不实，需要巩固。如沙地，需要加固才能建设。',
    characteristics: ['松散不实', '需要巩固', '性格多变', '需要磨练', '潜力巨大', '基础不稳'],
    fortune: '早年运势不稳，如沙土般松散。需要努力巩固，中年后逐渐稳定。适合从事建筑、工程等需要打基础的工作。'
  },
  '天上火': {
    name: '天上火',
    element: '火',
    desc: '天上之火，太阳之光，有照耀之功。如太阳当空，照耀万物。',
    characteristics: ['太阳之光', '照耀万物', '性格热情', '光明磊落', '有领导力', '光芒四射'],
    fortune: '一生光明磊落，如太阳般照耀。有领导才能，能够成就大事。适合从事领导、管理、公众人物等需要光芒的工作。'
  },
  '石榴木': {
    name: '石榴木',
    element: '木',
    desc: '石榴之木，硕果累累，有收获之功。如石榴树，果实累累。',
    characteristics: ['硕果累累', '收获之功', '性格务实', '善于积累', '勤劳肯干', '丰收之相'],
    fortune: '一生勤劳肯干，如石榴般硕果累累。能够积累财富，晚年富贵。适合从事农业、投资、实业等能够收获的工作。'
  },
  '大海水': {
    name: '大海水',
    element: '水',
    desc: '大海之水，浩瀚无边，有包容之功。如大海般浩瀚，包容万物。',
    characteristics: ['浩瀚无边', '包容万物', '性格宽广', '智慧深邃', '有气度', '深不可测'],
    fortune: '一生气度恢宏，如大海般浩瀚。能够包容万物，成就大事。适合从事航运、贸易、外交等需要大格局的工作。'
  }
};

// 十二长生状态
export const CHANGSHENG: Record<string, ChangShengInfo> = {
  '长生': {
    name: '长生',
    meaning: '万物生发，如人初生',
    desc: '长生代表事物的开始，如婴儿初生，充满生机和希望。在命局中表示新的开始、机遇和成长。',
    characteristics: '具有强大的生命力和创造力，容易获得新的机会，适合开创事业。性格积极向上，充满活力。'
  },
  '沐浴': {
    name: '沐浴',
    meaning: '万物萌发，如人沐浴',
    desc: '沐浴代表事物的成长初期，如婴儿沐浴，需要呵护。在命局中表示需要培养和保护的阶段。',
    characteristics: '需要呵护和培养，容易受到外界影响。性格敏感，需要稳定的环境才能成长。'
  },
  '冠带': {
    name: '冠带',
    meaning: '万物渐长，如人成年',
    desc: '冠带代表事物的成长期，如人成年冠带，开始承担责任。在命局中表示逐渐成熟，开始承担责任。',
    characteristics: '开始承担责任，逐渐成熟。性格稳重，有责任感，适合承担重要工作。'
  },
  '临官': {
    name: '临官',
    meaning: '万物强壮，如人任职',
    desc: '临官代表事物的成熟期，如人任职为官，有能力胜任。在命局中表示能力强，能够胜任工作。',
    characteristics: '能力强，能够胜任重要工作。性格自信，有领导才能，事业有成。'
  },
  '帝旺': {
    name: '帝旺',
    meaning: '万物极盛，如人巅峰',
    desc: '帝旺代表事物的巅峰期，如人事业巅峰，权势最盛。在命局中表示达到巅峰，但也要注意盛极而衰。',
    characteristics: '达到巅峰，权势最盛。性格强势，有领导力，但要注意盛极而衰，需要适时收敛。'
  },
  '衰': {
    name: '衰',
    meaning: '万物渐衰，如人衰老',
    desc: '衰代表事物的衰退期，如人开始衰老，精力减退。在命局中表示开始走下坡路，需要调整。',
    characteristics: '开始走下坡路，精力减退。性格可能变得保守，需要调整心态，接受变化。'
  },
  '病': {
    name: '病',
    meaning: '万物困顿，如人患病',
    desc: '病代表事物的困顿期，如人患病，需要治疗。在命局中表示遇到困难，需要解决。',
    characteristics: '遇到困难，需要解决。性格可能变得消极，需要积极面对，寻找解决方法。'
  },
  '死': {
    name: '死',
    meaning: '万物终结，如人死亡',
    desc: '死代表事物的终结期，如人死亡，一切结束。在命局中表示结束，但也是新的开始的前奏。',
    characteristics: '事物结束，但也是新的开始的前奏。性格需要接受结束，准备新的开始。'
  },
  '墓': {
    name: '墓',
    meaning: '万物收藏，如人入墓',
    desc: '墓代表事物的收藏期，如人入墓，归于尘土。在命局中表示收藏、积累，等待时机。',
    characteristics: '收藏、积累，等待时机。性格内敛，善于积累，等待合适的时机再行动。'
  },
  '绝': {
    name: '绝',
    meaning: '万物断绝，如人绝境',
    desc: '绝代表事物的断绝期，如人陷入绝境，需要突破。在命局中表示绝境，但也是转机的开始。',
    characteristics: '陷入绝境，但也是转机的开始。性格需要突破，寻找新的机会和方向。'
  },
  '胎': {
    name: '胎',
    meaning: '万物怀胎，如人受胎',
    desc: '胎代表事物的孕育期，如人受胎，新的开始。在命局中表示新的机会正在孕育中。',
    characteristics: '新的机会正在孕育中。性格需要耐心等待，准备迎接新的开始。'
  },
  '养': {
    name: '养',
    meaning: '万物养育，如人受养',
    desc: '养代表事物的养育期，如人受养育，成长中。在命局表示正在成长，需要呵护。',
    characteristics: '正在成长，需要呵护和培养。性格温和，需要稳定的环境才能成长。'
  }
};

// 神煞系统
export const SHENSHA: Record<string, ShenShaInfo> = {
  // 吉神
  '天乙贵人': {
    name: '天乙贵人',
    type: '吉',
    desc: '天乙贵人为众神煞之首，主贵人相助，逢凶化吉',
    effect: '一生有贵人相助，遇到困难时总有人帮助。能够逢凶化吉，转危为安。适合从事需要人脉和贵人支持的工作。',
    position: '以日干查地支，甲戊见牛羊，乙己鼠猴乡，丙丁猪鸡位，壬癸蛇兔藏，六辛逢马虎'
  },
  '太极贵人': {
    name: '太极贵人',
    type: '吉',
    desc: '太极贵人主聪明好学，对玄学、宗教有缘',
    effect: '聪明好学，对玄学、宗教、哲学有浓厚兴趣。有悟性，适合从事研究、学术、宗教等工作。',
    position: '以日干查地支，甲乙生人子午中，丙丁鸡兔定亨通，戊己两干临四季，庚辛寅亥禄丰隆，壬癸巳申偏喜美'
  },
  '天德贵人': {
    name: '天德贵人',
    type: '吉',
    desc: '天德贵人主福德，一生平安，逢凶化吉',
    effect: '一生有福德，平安顺遂。心地善良，乐于助人。能够逢凶化吉，灾祸减少。',
    position: '正月见丁，二月见申，三月见壬，四月见辛，五月见甲，六月见癸，七月见寅，八月见丙，九月见乙，十月见巳，十一月见庚，十二月见戊'
  },
  '月德贵人': {
    name: '月德贵人',
    type: '吉',
    desc: '月德贵人主阴德，心地善良，为人所敬',
    effect: '心地善良，有阴德，为人所敬重。能够化解部分凶煞，增加福气。',
    position: '寅午戌月生人见丙，申子辰月生人见壬，亥卯未月生人见甲，巳酉丑月生人见庚'
  },
  '文昌贵人': {
    name: '文昌贵人',
    type: '吉',
    desc: '文昌贵人主聪明智慧，学业有成',
    effect: '聪明智慧，学业有成，考试顺利。有文学艺术天赋，适合从事文化、教育、学术等工作。',
    position: '以日干查地支，甲乙见巳，丙戊见申，丁己见酉，庚见亥，辛见子，壬见寅，癸见卯'
  },
  '文曲贵人': {
    name: '文曲贵人',
    type: '吉',
    desc: '文曲贵人主才艺，有艺术天赋',
    effect: '有艺术天赋，擅长音乐、绘画、文学等。有创造力，适合从事艺术、创意等工作。',
    position: '与文昌贵人相对的地支'
  },
  '福星贵人': {
    name: '福星贵人',
    type: '吉',
    desc: '福星贵人主福气，一生平安幸福',
    effect: '一生有福气，平安幸福。性格乐观，容易满足。能够得到家人和朋友的关爱。',
    position: '以日干查地支，甲丙见寅，乙癸见丑，戊见申，己见未，丁见亥，庚见午，辛见巳，壬见辰'
  },
  '桃花': {
    name: '桃花',
    type: '中',
    desc: '桃花主人缘，异性缘好，但也可能感情复杂',
    effect: '人缘好，异性缘佳，有魅力。但也可能感情复杂，需要注意感情问题。适合从事需要人缘的工作，如公关、销售等。',
    position: '以日支查地支，申子辰见酉，寅午戌见卯，巳酉丑见午，亥卯未见子'
  },
  // 凶煞
  '劫煞': {
    name: '劫煞',
    type: '凶',
    desc: '劫煞主劫难，容易遇到意外和损失',
    effect: '容易遇到意外、损失、被抢劫等情况。需要注意安全，避免冒险行为。购买保险，做好防范措施。',
    position: '以日支查地支，申子辰见巳，寅午戌见亥，巳酉丑见寅，亥卯未见申'
  },
  '亡神': {
    name: '亡神',
    type: '凶',
    desc: '亡神主疾病和死亡，需要注意健康',
    effect: '需要注意健康，容易患病。也可能暗示亲人离世。需要注重养生，定期体检，珍惜与亲人相处的时光。',
    position: '以日支查地支，申子辰见亥，寅午戌见巳，巳酉丑见申，亥卯未见寅'
  },
  '孤辰': {
    name: '孤辰',
    type: '凶',
    desc: '孤辰主孤独，容易孤独终老',
    effect: '性格孤独，不善交际，容易孤独。需要主动社交，培养兴趣爱好，避免孤独终老。',
    position: '以日支查地支，亥子丑人见寅，寅卯辰人见巳，巳午未人见申，申酉戌人见亥'
  },
  '寡宿': {
    name: '寡宿',
    type: '凶',
    desc: '寡宿主孤独，婚姻不顺',
    effect: '婚姻不顺，容易孤独。特别是对女性影响更大。需要珍惜感情，努力经营婚姻。',
    position: '以日支查地支，亥子丑人见戌，寅卯辰人见丑，巳午未人见辰，申酉戌人见未'
  },
  '阴差阳错': {
    name: '阴差阳错',
    type: '凶',
    desc: '阴差阳错主婚姻不顺，夫妻不和',
    effect: '婚姻不顺，夫妻容易不和，甚至离婚。需要相互理解，包容对方，努力经营婚姻。',
    position: '日柱为丙子、丁丑、戊寅、辛卯、壬辰、癸巳、丙午、丁未、戊申、辛酉、壬戌、癸亥'
  },
  '羊刃': {
    name: '羊刃',
    type: '凶',
    desc: '羊刃主刚强暴躁，容易伤人',
    effect: '性格刚强暴躁，容易与人发生冲突，甚至伤人。需要控制脾气，学会冷静，避免暴力行为。',
    position: '甲羊刃在卯，乙羊刃在寅，丙戊羊刃在午，丁己羊刃在巳，庚羊刃在酉，辛羊刃在申，壬羊刃在子，癸羊刃在亥'
  },
  '驿马': {
    name: '驿马',
    type: '中',
    desc: '驿马主变动，奔波劳碌',
    effect: '一生奔波劳碌，经常变动，适合从事需要出差、流动的工作。也可能暗示移民、留学等。',
    position: '以日支查地支，申子辰见寅，寅午戌见申，巳酉丑见亥，亥卯未见巳'
  }
};

// 获取十二长生状态
export function getChangShengStatus(dayMaster: string, targetBranch: string): string {
  const changShengOrder = ['长生', '沐浴', '冠带', '临官', '帝旺', '衰', '病', '死', '墓', '绝', '胎', '养'];
  
  // 十二长生对应的地支
  const changShengMap: Record<string, string[]> = {
    '甲': ['亥', '子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌'],
    '乙': ['午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌', '酉', '申', '未'],
    '丙': ['寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑'],
    '丁': ['酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌'],
    '戊': ['寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑'],
    '己': ['酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑', '子', '亥', '戌'],
    '庚': ['巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑', '寅', '卯', '辰'],
    '辛': ['子', '亥', '戌', '酉', '申', '未', '午', '巳', '辰', '卯', '寅', '丑'],
    '壬': ['申', '酉', '戌', '亥', '子', '丑', '寅', '卯', '辰', '巳', '午', '未'],
    '癸': ['卯', '寅', '丑', '子', '亥', '戌', '酉', '申', '未', '午', '巳', '辰']
  };
  
  const branches = changShengMap[dayMaster];
  if (!branches) return '未知';
  
  const index = branches.indexOf(targetBranch);
  if (index === -1) return '未知';
  
  return changShengOrder[index];
}

// 获取神煞列表
export function getShenShaList(bazi: { year: string; month: string; day: string; hour: string }): string[] {
  const shenShaList: string[] = [];
  
  // 验证输入数据
  if (!bazi || !bazi.day || typeof bazi.day !== 'string') {
    return shenShaList;
  }
  
  const dayMaster = bazi.day.charAt(0);
  const dayBranch = bazi.day.charAt(1);
  
  // 验证日主干支
  if (!dayMaster || !dayBranch) {
    return shenShaList;
  }
  
  // 天乙贵人检查
  const tianYiMap: Record<string, string[]> = {
    '甲': ['丑', '未'],
    '乙': ['子', '申'],
    '丙': ['亥', '酉'],
    '丁': ['亥', '酉'],
    '戊': ['丑', '未'],
    '己': ['子', '申'],
    '庚': ['丑', '未'],
    '辛': ['寅', '午'],
    '壬': ['卯', '巳'],
    '癸': ['卯', '巳']
  };
  
  const tianYiBranches = tianYiMap[dayMaster] || [];
  const pillarsToCheck = [bazi.year, bazi.month, bazi.day, bazi.hour].filter((g): g is string => typeof g === 'string' && g.length >= 2);
  
  pillarsToCheck.forEach(ganZhi => {
    if (tianYiBranches.includes(ganZhi.charAt(1))) {
      if (!shenShaList.includes('天乙贵人')) {
        shenShaList.push('天乙贵人');
      }
    }
  });
  
  // 桃花检查
  const taoHuaMap: Record<string, string> = {
    '申': '酉', '子': '酉', '辰': '酉',
    '寅': '卯', '午': '卯', '戌': '卯',
    '巳': '午', '酉': '午', '丑': '午',
    '亥': '子', '卯': '子', '未': '子'
  };
  
  const taoHua = taoHuaMap[dayBranch];
  if (taoHua) {
    pillarsToCheck.forEach(ganZhi => {
      if (ganZhi.charAt(1) === taoHua) {
        if (!shenShaList.includes('桃花')) {
          shenShaList.push('桃花');
        }
      }
    });
  }
  
  // 文昌贵人检查
  const wenChangMap: Record<string, string> = {
    '甲': '巳', '乙': '午', '丙': '申', '丁': '酉', '戊': '申',
    '己': '酉', '庚': '亥', '辛': '子', '壬': '寅', '癸': '卯'
  };
  
  const wenChang = wenChangMap[dayMaster];
  if (wenChang) {
    pillarsToCheck.forEach(ganZhi => {
      if (ganZhi.charAt(1) === wenChang) {
        if (!shenShaList.includes('文昌贵人')) {
          shenShaList.push('文昌贵人');
        }
      }
    });
  }
  
  // 驿马检查
  const yiMaMap: Record<string, string> = {
    '申': '寅', '子': '寅', '辰': '寅',
    '寅': '申', '午': '申', '戌': '申',
    '巳': '亥', '酉': '亥', '丑': '亥',
    '亥': '巳', '卯': '巳', '未': '巳'
  };
  
  const yiMa = yiMaMap[dayBranch];
  if (yiMa) {
    pillarsToCheck.forEach(ganZhi => {
      if (ganZhi.charAt(1) === yiMa) {
        if (!shenShaList.includes('驿马')) {
          shenShaList.push('驿马');
        }
      }
    });
  }
  
  return shenShaList;
}

// 十神详细描述
export const SHISHEN_DETAIL: Record<string, ShiShenDesc> = {
  '比肩': {
    desc: '兄弟姐妹、朋友、同事等平辈关系',
    nature: '独立、自主、固执、有主见',
    detail: '比肩代表与自己同类的力量，象征兄弟姐妹、朋友、同事等平辈关系。性格上表现为独立自主、有主见，但也可能过于固执己见。比肩帮身，能够增强日主的力量，但过多则会分夺财源。比肩之人重情重义，重视友情，但也容易与人竞争。',
    strengths: ['独立自主', '有主见', '自信自强', '不依赖他人', '有竞争力', '重情重义'],
    weaknesses: ['固执己见', '不善于合作', '容易与人竞争', '过于自我', '不善于妥协', '容易树敌'],
    career: ['自由职业', '独立创业', '技术工作', '竞技体育', '销售业务', '个体经营'],
    relationships: '与平辈关系平等，不易受制于他人，适合平等相待的关系。重友情，但容易因为竞争而破坏关系。',
    wealth: '需要通过自己的努力获得财富，不宜依赖他人。适合独立经营，自主创造财富。'
  },
  '劫财': {
    desc: '竞争、争夺、破财、异性兄弟姐妹',
    nature: '豪爽、冒险、冲动、有魄力',
    detail: '劫财代表与自己争夺的力量，象征竞争、争夺、破财等。性格上表现为豪爽大方、喜欢冒险，但也容易冲动行事。劫财克财，需要注意财务管理，避免破财。劫财之人敢于冒险，有魄力，但也容易因为冲动而损失财物。',
    strengths: ['豪爽大方', '敢于冒险', '行动力强', '有魄力', '乐于助人', '重义气'],
    weaknesses: ['容易冲动', '不善理财', '好赌冒险', '容易破财', '过于激进', '容易受骗'],
    career: ['投机行业', '高风险投资', '竞技体育', '销售业务', '军事警察', '冒险活动'],
    relationships: '容易与人产生竞争关系，需要注意处理好人际关系。豪爽大方，但也容易因为钱财问题产生矛盾。',
    wealth: '财运起伏较大，需要谨慎理财，避免冒险投资。容易来得快去得也快，需要学会守财。'
  },
  '食神': {
    desc: '才华、享受、子女、口福、艺术',
    nature: '温和、艺术、口福、创造力',
    detail: '食神代表我生之物，象征才华、享受、子女、口福等。性格上表现为温和善良、有艺术天赋，懂得享受生活。食神生财，是财星的源头，代表通过才华获得财富。食神之人有口福，喜欢美食，也善于创造美好的事物。',
    strengths: ['温和善良', '有艺术天赋', '懂得享受', '有口福', '有创造力', '心地善良'],
    weaknesses: ['过于安逸', '缺乏进取心', '容易满足', '不够务实', '贪图享受', '容易发胖'],
    career: ['艺术创作', '餐饮美食', '教育培训', '娱乐文化', '设计创意', '文化工作'],
    relationships: '待人温和，容易相处，子女缘好。懂得享受生活，能够给他人带来快乐。',
    wealth: '可以通过才华和创意获得财富，适合从事文化艺术工作。食神生财，财运稳定。'
  },
  '伤官': {
    desc: '才华、叛逆、创新、口才、技术',
    nature: '聪明、叛逆、口才、创造力',
    detail: '伤官代表我生之物但过于极端，象征才华、叛逆、创新等。性格上表现为聪明机智、有创造力，但也可能叛逆不羁、口无遮拦。伤官见官为祸百端，需要注意言行。伤官之人才华横溢，但也容易因为言辞得罪人。',
    strengths: ['聪明机智', '有创造力', '口才出众', '思维敏捷', '敢于创新', '才华横溢'],
    weaknesses: ['叛逆不羁', '口无遮拦', '容易得罪人', '过于自负', '不善守规矩', '容易惹祸'],
    career: ['创意策划', '演讲主持', '技术研发', '艺术表演', '自由职业', '咨询顾问'],
    relationships: '容易因为言辞得罪人，需要注意沟通方式。聪明机智，但也容易让人感到尖锐。',
    wealth: '可以通过创新和才华获得财富，但要注意法律风险。伤官生财，适合靠技术赚钱。'
  },
  '偏财': {
    desc: '横财、父亲、情人、投机、社交',
    nature: '慷慨、善交际、风流、机会主义',
    detail: '偏财代表我克之物但不完全占有，象征横财、父亲、情人等。性格上表现为慷慨大方、善于交际，但也可能风流多情。偏财来得快去得也快，需要注意理财。偏财之人善于把握机会，有商业头脑，但也容易因为感情问题影响事业。',
    strengths: ['慷慨大方', '善于交际', '机会敏锐', '敢于冒险', '人缘好', '商业头脑'],
    weaknesses: ['风流多情', '不善理财', '容易挥霍', '感情不稳定', '过于投机', '缺乏恒心'],
    career: ['投资理财', '贸易经商', '娱乐行业', '销售业务', '公关交际', '商业活动'],
    relationships: '感情丰富，人缘好，但要注意感情专一。慷慨大方，容易吸引异性，但也容易感情复杂。',
    wealth: '可以通过投资和交际获得财富，但财运起伏较大。适合从事商业活动，但要注意守财。'
  },
  '正财': {
    desc: '妻子、正当收入、财产、稳定、务实',
    nature: '节俭、务实、保守、重视家庭',
    detail: '正财代表我克之物且完全占有，象征妻子、正当收入、财产等。性格上表现为节俭务实、稳重保守，重视物质生活。正财稳定持久，适合从事稳定工作。正财之人重视家庭，对伴侣忠诚，是可靠的伴侣。',
    strengths: ['节俭务实', '稳重保守', '善于理财', '重视家庭', '踏实肯干', '忠诚可靠'],
    weaknesses: ['过于保守', '缺乏冒险精神', '过于看重金钱', '不够浪漫', '吝啬小气', '缺乏激情'],
    career: ['财务会计', '行政管理', '实业经营', '金融投资', '稳定职业', '公务员'],
    relationships: '重视家庭，对伴侣忠诚，适合稳定长久的关系。务实可靠，是理想的伴侣。',
    wealth: '可以通过稳定工作积累财富，财运平稳持久。适合从事稳定职业，逐步积累财富。'
  },
  '偏印': {
    desc: '继母、偏门学问、孤独、特殊才能',
    nature: '敏感、孤僻、多疑、独特思维',
    detail: '偏印代表生我之物但不完全付出，象征继母、偏门学问、孤独等。性格上表现为敏感多疑、喜欢独处，有特殊的兴趣爱好。偏印主孤独，容易与他人保持距离。偏印之人思维独特，有特殊才能，但也容易钻牛角尖。',
    strengths: ['思维独特', '有特殊才能', '善于思考', '独立思考', '有研究精神', '悟性高'],
    weaknesses: ['敏感多疑', '喜欢孤独', '不善交际', '过于敏感', '容易钻牛角尖', '缺乏安全感'],
    career: ['玄学命理', '特殊技艺', '艺术创作', '学术研究', '技术研发', '神秘学'],
    relationships: '容易与人保持距离，不善于表达情感。喜欢独处，但也需要学会与人交流。',
    wealth: '可以通过特殊才能获得财富，但不善于理财。适合从事独特的工作，靠特殊才能赚钱。'
  },
  '正印': {
    desc: '母亲、学业、贵人、文化、名誉',
    nature: '仁慈、好学、依赖、有修养',
    detail: '正印代表生我之物且完全付出，象征母亲、学业、贵人等。性格上表现为仁慈善良、好学上进，但也可能过于依赖他人。正印主贵，容易得到贵人相助。正印之人有文化修养，乐于助人，容易获得他人的尊重。',
    strengths: ['仁慈善良', '好学上进', '有文化修养', '乐于助人', '容易得贵人', '德高望重'],
    weaknesses: ['过于依赖', '缺乏独立性', '过于理想化', '不够务实', '依赖心重', '容易受骗'],
    career: ['教育文化', '学术研究', '公务员', '法律政治', '医疗护理', '公益事业'],
    relationships: '待人仁慈，乐于助人，容易得到他人的帮助。有贵人缘，适合从事需要人脉的工作。',
    wealth: '可以通过正当途径获得财富，财运稳定。适合从事稳定职业，依靠学识和贵人获得财富。'
  },
  '七杀': {
    desc: '偏夫、压力、小人、挑战、权威',
    nature: '威严、果决、暴躁、有魄力',
    detail: '七杀代表克我之物且力量强大，象征偏夫、压力、小人等。性格上表现为威严果断、有魄力，但也容易暴躁易怒。七杀需要有制，否则为祸。七杀之人有领导才能，但也容易树敌，需要学会控制脾气。',
    strengths: ['威严果断', '有魄力', '敢于挑战', '有领导力', '执行力强', '不畏强敌'],
    weaknesses: ['暴躁易怒', '容易树敌', '压力过大', '容易冲动', '缺乏耐心', '容易惹祸'],
    career: ['军警武职', '企业管理', '法律政治', '外科医生', '体育竞技', '危险行业'],
    relationships: '性格强势，容易与人发生冲突。需要学会控制脾气，避免因为冲动破坏关系。',
    wealth: '可以通过挑战和竞争获得财富，但风险较大。适合从事高风险高回报的工作。'
  },
  '正官': {
    desc: '丈夫、上司、官职、规则、名誉',
    nature: '正直、守法、稳重、有责任感',
    detail: '正官代表克我之物且有节制，象征丈夫、上司、官职等。性格上表现为正直守法、稳重可靠，重视规则和秩序。正官是吉星，代表社会地位和名誉。正官之人适合从事公职，能够获得社会认可。',
    strengths: ['正直守法', '稳重可靠', '重视规则', '有责任感', '社会地位', '名誉良好'],
    weaknesses: ['过于保守', '缺乏创新', '过于看重规则', '不够灵活', '容易墨守成规', '缺乏冒险精神'],
    career: ['公务员', '企业管理', '法律政治', '教育文化', '行政管理', '公职人员'],
    relationships: '重视规则和秩序，对伴侣忠诚。适合稳定长久的关系，是可靠的伴侣。',
    wealth: '可以通过正当途径获得财富，财运稳定。适合从事稳定职业，依靠职位获得财富。'
  }
};

// 格局详细描述
export const GEJU_DETAIL: Record<string, GeJuInfo> = {
  '正官格': {
    desc: '日主身旺，正官有力，官星清透',
    detail: '正官格是最理想的格局之一，代表为人正直、遵守规则、有责任感。命主适合从事公职、管理工作，能够获得社会认可和地位。性格稳重可靠，做事有条理，重视规则和秩序。官星清透，无煞星混杂，则一生平安顺遂，能够得到贵人相助。',
    career: '公务员、企业管理、法律、教育、行政管理、公职人员',
    personality: '正直、守法、稳重、有责任感、重视规则、做事有条理',
    strengths: ['正直守法', '稳重可靠', '有责任感', '重视规则', '社会地位高', '名誉良好', '做事有条理', '容易得贵人'],
    weaknesses: ['过于保守', '缺乏创新', '不够灵活', '容易墨守成规', '有时过于死板', '缺乏冒险精神'],
    requirements: ['日主身旺', '正官有力', '官星清透', '无煞星混杂', '印星相生'],
    famousExamples: ['包拯', '海瑞', '诸葛亮']
  },
  '七杀格': {
    desc: '日主身旺，七杀有力，有制化',
    detail: '七杀格代表有魄力、有威严、敢于冒险。命主适合从事武职、创业、高风险高回报的行业。性格果断决绝，有领导才能，但也需要注意控制脾气。七杀需要有制，如食神制杀或印星化杀，否则容易有灾祸。',
    career: '军人、警察、创业、投资、外科医生、体育竞技、危险行业',
    personality: '威严、果断、有魄力、敢于冒险、执行力强、不畏挑战',
    strengths: ['威严果断', '有魄力', '敢于挑战', '有领导力', '执行力强', '不畏强敌', '敢于冒险', '有威严'],
    weaknesses: ['暴躁易怒', '容易树敌', '压力过大', '容易冲动', '缺乏耐心', '容易惹祸', '性格过强', '容易得罪人'],
    requirements: ['日主身旺', '七杀有力', '有制化（食神或印星）', '不宜七杀过多'],
    famousExamples: ['岳飞', '戚继光', '成吉思汗']
  },
  '正印格': {
    desc: '日主身弱，正印有力，印星生身',
    detail: '正印格代表有学识、有修养、心地善良。命主适合从事学术研究、教育、文化工作。性格温和仁慈，喜欢帮助他人，容易得到贵人相助。正印生身，能够增强日主的力量，使命主有智慧和文化修养。',
    career: '教育、研究、文化、慈善、医疗、学术、公益事业',
    personality: '仁慈、好学、有修养、善良、温和、有文化',
    strengths: ['仁慈善良', '好学上进', '有修养', '有文化', '心地善良', '容易得贵人', '德高望重', '乐于助人'],
    weaknesses: ['过于依赖', '缺乏独立性', '过于理想化', '不够务实', '依赖心重', '容易受骗', '有时过于软弱', '缺乏主见'],
    requirements: ['日主身弱', '正印有力', '印星生身', '不宜印星过多'],
    famousExamples: ['孔子', '孟子', '朱熹']
  },
  '偏印格': {
    desc: '日主身弱，偏印有力，有特殊才能',
    detail: '偏印格代表有特殊才能、喜欢独处、思维独特。命主适合从事特殊技艺、玄学、艺术等工作。性格敏感多疑，有独特的思维方式，但也容易与人保持距离。偏印生身，能够增强日主的力量，使命主有特殊才能。',
    career: '艺术、玄学、特殊技艺、研究、技术研发、神秘学',
    personality: '敏感、独特、孤僻、有才华、思维独特、喜欢独处',
    strengths: ['思维独特', '有特殊才能', '善于思考', '独立思考', '有研究精神', '悟性高', '有特殊技能', '与众不同'],
    weaknesses: ['敏感多疑', '喜欢孤独', '不善交际', '过于敏感', '容易钻牛角尖', '缺乏安全感', '容易与人保持距离', '过于孤僻'],
    requirements: ['日主身弱', '偏印有力', '不宜偏印过多', '需要偏财配合'],
    famousExamples: ['李白', '梵高', '爱因斯坦']
  },
  '正财格': {
    desc: '日主身旺，正财有力，财星有源',
    detail: '正财格代表财运稳定、重视物质、勤俭持家。命主适合从事商业、财务、金融等工作。性格务实稳重，善于理财，重视家庭生活。正财有源，如食神生财，则财运亨通。正财之人重视家庭，是可靠的伴侣。',
    career: '商业、金融、财务、实业、会计、投资、稳定职业',
    personality: '务实、勤俭、稳重、重视物质、重视家庭、善于理财',
    strengths: ['节俭务实', '稳重可靠', '善于理财', '重视家庭', '踏实肯干', '忠诚可靠', '财运稳定', '勤俭持家'],
    weaknesses: ['过于保守', '缺乏冒险精神', '过于看重金钱', '不够浪漫', '吝啬小气', '缺乏激情', '有时过于计较', '不够大方'],
    requirements: ['日主身旺', '正财有力', '财星有源', '不宜财星过多'],
    famousExamples: ['范蠡', '白圭', '胡雪岩']
  },
  '偏财格': {
    desc: '日主身旺，偏财有力，善于把握机会',
    detail: '偏财格代表财运亨通、慷慨大方、善于交际。命主适合从事投资、贸易、娱乐等行业。性格豪爽开朗，善于把握机会，财运起伏较大。偏财之人慷慨大方，善于交际，但也需要注意理财。',
    career: '投资、贸易、娱乐、销售、公关、商业、股票期货',
    personality: '豪爽、慷慨、善交际、冒险、机会主义、慷慨大方',
    strengths: ['慷慨大方', '善于交际', '机会敏锐', '敢于冒险', '人缘好', '商业头脑', '善于把握机会', '豪爽开朗'],
    weaknesses: ['风流多情', '不善理财', '容易挥霍', '感情不稳定', '过于投机', '缺乏恒心', '财运起伏大', '容易破财'],
    requirements: ['日主身旺', '偏财有力', '不宜偏财过多', '需要食伤生财'],
    famousExamples: ['吕不韦', '沈万三', '伍秉鉴']
  },
  '食神格': {
    desc: '日主身旺，食神有力，食神生财',
    detail: '食神格代表有才华、懂享受、性格温和。命主适合从事艺术、餐饮、娱乐等工作。性格温和善良，有艺术天赋，懂得享受生活。食神生财，财运亨通。食神之人心地善良，有口福，也喜欢创造美好的事物。',
    career: '艺术、餐饮、娱乐、文化、设计、教育、创意',
    personality: '温和、才华、享受、善良、有艺术天赋、懂得生活',
    strengths: ['温和善良', '有艺术天赋', '懂得享受', '有口福', '有创造力', '心地善良', '财运亨通', '性格温和'],
    weaknesses: ['过于安逸', '缺乏进取心', '容易满足', '不够务实', '贪图享受', '容易发胖', '有时过于懒散', '缺乏竞争意识'],
    requirements: ['日主身旺', '食神有力', '不宜食神过多', '食神生财为佳'],
    famousExamples: ['苏轼', '唐伯虎', '曹雪芹']
  },
  '伤官格': {
    desc: '日主身旺，伤官有力，伤官配印',
    detail: '伤官格代表才华横溢、叛逆创新、口才出众。命主适合从事创意、演讲、技术等工作。性格聪明机智，有创造力，但也容易叛逆不羁。伤官配印，能够化解伤官的负面影响，发挥才华。',
    career: '创意、技术、演讲、艺术、咨询、自由职业、写作',
    personality: '聪明、叛逆、创新、口才好、才华横溢、思维敏捷',
    strengths: ['聪明机智', '有创造力', '口才出众', '思维敏捷', '敢于创新', '才华横溢', '有独特见解', '不甘平庸'],
    weaknesses: ['叛逆不羁', '口无遮拦', '容易得罪人', '过于自负', '不善守规矩', '容易惹祸', '有时过于尖锐', '不甘约束'],
    requirements: ['日主身旺', '伤官有力', '需要配印化解', '不宜伤官过多'],
    famousExamples: ['屈原', '李白', '鲁迅']
  },
  '建禄格': {
    desc: '日主得月令之气，身强有力',
    detail: '建禄格代表根基稳固、身体健康、自力更生。命主通常身体强健，能够自力更生，不依赖他人。性格独立坚强，有奋斗精神。建禄格之人自尊心强，不轻易求人，凡事喜欢亲力亲为。',
    career: '适合各种实业、技术工作、独立创业、自由职业',
    personality: '独立、坚强、健康、奋斗、自力更生、自尊心强',
    strengths: ['身体健康', '根基稳固', '自力更生', '独立坚强', '有奋斗精神', '自尊心强', '凡事亲力亲为', '不依赖他人'],
    weaknesses: ['过于独立', '不轻易求人', '有时过于固执', '缺乏合作精神', '容易劳累', '不善分工', '有时过于要强', '容易身心俱疲'],
    requirements: ['日主得月令之气', '日主身旺', '不宜禄神过多'],
    famousExamples: ['项羽', '关羽', '张飞']
  },
  '月刃格': {
    desc: '日主得月令之气但过旺，需要制化',
    detail: '月刃格代表性格刚强、有魄力、但容易冲动。命主需要注意控制脾气，避免与人发生冲突。适合从事武职、创业等需要魄力的工作。月刃格之人刚强果断，但也容易树敌，需要学会控制。',
    career: '武职、创业、体育、军警、外科医生、竞技行业',
    personality: '刚强、冲动、有魄力、果断、勇敢、不畏强敌',
    strengths: ['刚强果断', '有魄力', '勇敢无畏', '执行力强', '敢于挑战', '不畏强敌', '果断决策', '有领导才能'],
    weaknesses: ['容易冲动', '容易树敌', '脾气暴躁', '缺乏耐心', '容易得罪人', '有时过于暴力', '不善妥协', '容易惹祸'],
    requirements: ['日主得月令之气', '日主过旺', '需要制化', '不宜月刃过多'],
    famousExamples: ['吕布', '典韦', '许褚']
  }
};

// 日主详细描述
export const DAYMASTER_DETAIL: Record<string, DayMasterInfo> = {
  '甲': {
    desc: '甲木为参天大树，生于春季则枝叶繁茂，生于秋季则易受金克。甲木之人性格刚直，有领导力，为人正直，但可能过于固执。甲木需要阳光（丙火）照耀，需要水源（癸水）滋养，需要土壤（戊土）扎根。',
    element: '木',
    nature: '阳',
    characteristics: ['刚直不阿', '有领导力', '为人正直', '固执己见', '独立性强', '有主见', '根基深厚', '向上生长'],
    suitableCareers: ['领导管理', '教育培训', '建筑工程', '木材家具', '园艺花卉', '政治法律', '军事武职', '创业经营'],
    favorableElements: ['火（阳光照耀）', '水（滋养生长）', '土（扎根稳固）'],
    unfavorableElements: ['金（克制太过）', '过多的水（水多木漂）'],
    famousPeople: ['秦始皇', '汉武帝', '康熙帝']
  },
  '乙': {
    desc: '乙木为花草藤蔓，柔韧性强，善于攀附。乙木之人性格柔和，善于变通，适应能力强，但可能缺乏主见。乙木需要支架（甲木）攀附，需要阳光（丙火）照耀，需要水源（癸水）滋养。',
    element: '木',
    nature: '阴',
    characteristics: ['性格柔和', '善于变通', '适应力强', '善解人意', '缺乏主见', '柔韧性强', '善于攀附', '温和善良'],
    suitableCareers: ['艺术设计', '文化娱乐', '咨询服务', '助理秘书', '教育培训', '公关交际', '医疗护理', '社会工作'],
    favorableElements: ['木（支架攀附）', '火（阳光照耀）', '水（滋养生长）'],
    unfavorableElements: ['金（克制太过）', '过多的土（土重木折）'],
    famousPeople: ['李清照', '林黛玉', '张爱玲']
  },
  '丙': {
    desc: '丙火为太阳之火，光芒万丈，照亮万物。丙火之人性格热情开朗，光明磊落，有奉献精神，但可能过于急躁。丙火需要木（甲乙木）生助，需要土（戊己土）收敛，不宜水（壬癸水）克制太过。',
    element: '火',
    nature: '阳',
    characteristics: ['热情开朗', '光明磊落', '无私奉献', '有感染力', '容易急躁', '光芒万丈', '照亮万物', '正义感强'],
    suitableCareers: ['政治领导', '公共事业', '教育培训', '文化传播', '娱乐演艺', '公关交际', '慈善事业', '能源电力'],
    favorableElements: ['木（生助火势）', '土（收敛火气）', '适度的水（调候）'],
    unfavorableElements: ['水（克制太过）', '过多的土（土重火熄）'],
    famousPeople: ['唐太宗', '宋太祖', '孙中山']
  },
  '丁': {
    desc: '丁火为灯烛之火，虽然光芒有限但持久稳定。丁火之人性格温和，心思细腻，有耐心，但可能缺乏魄力。丁火需要木（甲乙木）生助，需要金（庚辛金）劈木生火，不宜水（壬癸水）克制。',
    element: '火',
    nature: '阴',
    characteristics: ['温和细腻', '心思缜密', '持久稳定', '有耐心', '缺乏魄力', '光芒有限', '温暖持久', '文明礼貌'],
    suitableCareers: ['文化教育', '艺术设计', '科研技术', '医疗卫生', '咨询服务', '文秘助理', '宗教哲学', '照明电力'],
    favorableElements: ['木（生助火势）', '金（劈木生火）', '适度的土（保护灯火）'],
    unfavorableElements: ['水（克制太过）', '过多的土（土重火熄）'],
    famousPeople: ['蔡文姬', '卓文君', '林徽因']
  },
  '戊': {
    desc: '戊土为城墙之土，厚重稳固，能够承载万物。戊土之人性格稳重可靠，诚实守信，有包容心，但可能过于保守。戊土需要火（丙丁火）生助，需要木（甲乙木）疏土，不宜水（壬癸水）冲刷太过。',
    element: '土',
    nature: '阳',
    characteristics: ['稳重可靠', '诚实守信', '包容万物', '踏实肯干', '过于保守', '厚重稳固', '承载万物', '有责任感'],
    suitableCareers: ['建筑工程', '房地产', '农业种植', '矿产开发', '金融投资', '行政管理', '企业管理', '仓储物流'],
    favorableElements: ['火（生助土气）', '木（疏土有功）', '适度的水（滋润土壤）'],
    unfavorableElements: ['水（冲刷太过）', '过多的木（木重土虚）'],
    famousPeople: ['朱元璋', '雍正帝', '曾国藩']
  },
  '己': {
    desc: '己土为田园之土，肥沃滋养，养育万物。己土之人性格温和包容，善于照顾他人，但可能过于软弱。己土需要火（丙丁火）生助，需要木（甲乙木）疏土，需要金（庚辛金）泄土。',
    element: '土',
    nature: '阴',
    characteristics: ['温和包容', '善于照顾', '养育万物', '心细如发', '过于软弱', '肥沃滋养', '心思细腻', '有爱心'],
    suitableCareers: ['农业种植', '园艺花卉', '教育培训', '医疗卫生', '家政服务', '餐饮服务', '慈善公益', '心理咨询'],
    favorableElements: ['火（生助土气）', '木（疏土有功）', '金（泄土有功）'],
    unfavorableElements: ['水（浸泡太过）', '过多的木（木重土虚）'],
    famousPeople: ['武则天', '慈禧太后', '宋庆龄']
  },
  '庚': {
    desc: '庚金为刀剑之金，锋利坚硬，能够切割万物。庚金之人性格刚毅果断，有决断力，但可能过于冷酷。庚金需要火（丙丁火）锻炼，需要土（戊己土）生助，不宜木（甲乙木）克制太过。',
    element: '金',
    nature: '阳',
    characteristics: ['刚毅果断', '有决断力', '锐意进取', '勇往直前', '过于冷酷', '锋利坚硬', '切割万物', '执行力强'],
    suitableCareers: ['军警武职', '外科手术', '机械制造', '金属加工', '金融投资', '法律政治', '体育运动', '切割雕刻'],
    favorableElements: ['火（锻炼成器）', '土（生助金气）', '水（洗涤金气）'],
    unfavorableElements: ['木（克制太过）', '过多的火（火多金熔）'],
    famousPeople: ['曹操', '李世民', '成吉思汗']
  },
  '辛': {
    desc: '辛金为首饰之金，精致美丽，价值珍贵。辛金之人性格精致，追求完美，有艺术品味，但可能过于计较。辛金需要水（壬癸水）洗涤，需要土（戊己土）生助，不宜火（丙丁火）克制太过。',
    element: '金',
    nature: '阴',
    characteristics: ['精致完美', '有艺术品味', '注重细节', '心思细腻', '过于计较', '价值珍贵', '美丽动人', '追求完美'],
    suitableCareers: ['珠宝设计', '艺术创作', '时尚美容', '精密仪器', '金融财务', '装饰设计', '文化教育', '咨询顾问'],
    favorableElements: ['水（洗涤金气）', '土（生助金气）', '适度的火（锻炼成器）'],
    unfavorableElements: ['火（克制太过）', '过多的木（木重金缺）'],
    famousPeople: ['西施', '王昭君', '杨玉环']
  },
  '壬': {
    desc: '壬水为江河之水，奔流不息，浩瀚无垠。壬水之人性格奔放不羁，智慧深邃，善于思考，但可能过于随性。壬水需要土（戊己土）堤防，需要木（甲乙木）泄秀，不宜火（丙丁火）耗泄太过。',
    element: '水',
    nature: '阳',
    characteristics: ['奔放不羁', '智慧深邃', '善于思考', '随机应变', '过于随性', '奔流不息', '浩瀚无垠', '包容万物'],
    suitableCareers: ['航运贸易', '旅游探险', '教育培训', '咨询顾问', '文化传播', '外交外事', '科研探索', '水利环保'],
    favorableElements: ['土（堤防有功）', '木（泄秀有功）', '金（生助水气）'],
    unfavorableElements: ['火（耗泄太过）', '过多的土（土重水塞）'],
    famousPeople: ['庄子', '李白', '苏轼']
  },
  '癸': {
    desc: '癸水为雨露之水，滋润万物，细水长流。癸水之人性格含蓄内敛，善于思考，有智慧，但可能过于消极。癸水需要金（庚辛金）生助，需要木（甲乙木）泄秀，不宜土（戊己土）克制太过。',
    element: '水',
    nature: '阴',
    characteristics: ['含蓄内敛', '善于思考', '滋润万物', '智慧深沉', '过于消极', '细水长流', '润物无声', '心思缜密'],
    suitableCareers: ['科研学术', '文化教育', '心理咨询', '医疗卫生', '策划咨询', '宗教哲学', '艺术创作', '文秘助理'],
    favorableElements: ['金（生助水气）', '木（泄秀有功）', '适度的土（收敛水气）'],
    unfavorableElements: ['土（克制太过）', '过多的火（火多水干）'],
    famousPeople: ['老子', '孔子', '王阳明']
  }
};

// 喜用神分析
export function analyzeXiYongShen(bazi: { year: string; month: string; day: string; hour: string }): XiYongShen {
  // 输入验证
  if (!bazi || !bazi.day || typeof bazi.day !== 'string' || bazi.day.length < 2) {
    return {
      xiShen: '未知',
      yongShen: '未知',
      xiShenDesc: '数据不完整，无法分析',
      yongShenDesc: '数据不完整，无法分析',
      reason: '输入数据不完整',
      suggestions: ['请确保输入完整的八字信息', '检查日柱数据是否正确']
    };
  }
  
  const dayMaster = bazi.day.charAt(0);
  const dayMasterInfo = DAYMASTER_DETAIL[dayMaster];
  const monthBranch = bazi.month?.charAt(1);
  
  // 验证月支
  if (!monthBranch || !DIZHI_DETAIL[monthBranch]) {
    return {
      xiShen: '未知',
      yongShen: '未知',
      xiShenDesc: '月支数据不完整',
      yongShenDesc: '月支数据不完整',
      reason: '月支数据缺失或无效',
      suggestions: ['请检查月柱数据', '确保输入的出生时间正确']
    };
  }

  // 计算五行数量
  const wuxingCount = { '木': 0, '火': 0, '土': 0, '金': 0, '水': 0 };
  const allStems = [bazi.year.charAt(0), bazi.month.charAt(0), bazi.day.charAt(0), bazi.hour.charAt(0)];
  const allBranches = [bazi.year.charAt(1), bazi.month.charAt(1), bazi.day.charAt(1), bazi.hour.charAt(1)];
  
  // 计算天干五行
  allStems.forEach(stem => {
    const element = TIANGAN_DETAIL[stem]?.element;
    if (element) wuxingCount[element as keyof typeof wuxingCount]++;
  });
  
  // 计算地支五行（包括藏干）
  allBranches.forEach(branch => {
    const branchInfo = DIZHI_DETAIL[branch];
    if (branchInfo) {
      wuxingCount[branchInfo.element as keyof typeof wuxingCount]++;
      branchInfo.hidden.forEach(hiddenStem => {
        const hiddenElement = TIANGAN_DETAIL[hiddenStem]?.element;
        if (hiddenElement) wuxingCount[hiddenElement as keyof typeof wuxingCount] += 0.5;
      });
    }
  });
  
  const dayMasterElement = dayMasterInfo.element;
  
  // 判断身强身弱
  let strength = 'neutral';
  const sameElement = wuxingCount[dayMasterElement as keyof typeof wuxingCount];
  const generateElement = dayMasterElement === '木' ? wuxingCount['水'] :
                          dayMasterElement === '火' ? wuxingCount['木'] :
                          dayMasterElement === '土' ? wuxingCount['火'] :
                          dayMasterElement === '金' ? wuxingCount['土'] :
                          wuxingCount['金'];
  
  const supportScore = sameElement + generateElement;
  
  if (supportScore >= 4) {
    strength = 'strong';
  } else if (supportScore <= 2) {
    strength = 'weak';
  }
  
  // 根据身强身弱确定喜用神
  let xiShen = '';
  let yongShen = '';
  let xiShenDesc = '';
  let yongShenDesc = '';
  let reason = '';
  let suggestions: string[] = [];
  
  if (strength === 'strong') {
    // 身强需要克泄耗
    if (dayMasterElement === '木') {
      xiShen = '金';
      yongShen = '火';
      xiShenDesc = '金能克木，可以制约日主过旺的木气';
      yongShenDesc = '火能泄木，可以疏通日主旺木的气机';
      reason = '日主木旺，需要金来克制，火来泄秀';
      suggestions = ['适合从事金融、金属、机械等行业', '可佩戴金属饰品', '宜向西方发展', '适合红色、紫色等火色服饰'];
    } else if (dayMasterElement === '火') {
      xiShen = '水';
      yongShen = '土';
      xiShenDesc = '水能克火，可以制约日主过旺的火气';
      yongShenDesc = '土能泄火，可以疏通日主旺火的气机';
      reason = '日主火旺，需要水来克制，土来泄秀';
      suggestions = ['适合从事水产、航运、旅游等行业', '可近水而居', '宜向北方发展', '适合黄色、棕色等土色服饰'];
    } else if (dayMasterElement === '土') {
      xiShen = '木';
      yongShen = '金';
      xiShenDesc = '木能克土，可以制约日主过旺的土气';
      yongShenDesc = '金能泄土，可以疏通日主旺土的气机';
      reason = '日主土旺，需要木来克制，金来泄秀';
      suggestions = ['适合从事木材、园艺、教育等行业', '可多接触绿色植物', '宜向东方发展', '适合白色、金色等金色服饰'];
    } else if (dayMasterElement === '金') {
      xiShen = '火';
      yongShen = '水';
      xiShenDesc = '火能克金，可以制约日主过旺的金气';
      yongShenDesc = '水能泄金，可以疏通日主旺金的气机';
      reason = '日主金旺，需要火来克制，水来泄秀';
      suggestions = ['适合从事能源、电力、餐饮等行业', '可多用红色物品', '宜向南方发展', '适合黑色、蓝色等水色服饰'];
    } else if (dayMasterElement === '水') {
      xiShen = '土';
      yongShen = '木';
      xiShenDesc = '土能克水，可以制约日主过旺的水气';
      yongShenDesc = '木能泄水，可以疏通日主旺水的气机';
      reason = '日主水旺，需要土来克制，木来泄秀';
      suggestions = ['适合从事房地产、建筑、农业等行业', '可佩戴玉石', '宜向中央发展', '适合绿色、青色等木色服饰'];
    }
  } else if (strength === 'weak') {
    // 身弱需要生扶
    if (dayMasterElement === '木') {
      xiShen = '水';
      yongShen = '木';
      xiShenDesc = '水能生木，可以生扶日主衰弱的木气';
      yongShenDesc = '木能助木，可以帮助日主增强力量';
      reason = '日主木弱，需要水来生扶，木来助身';
      suggestions = ['适合从事水产、航运、文化等行业', '可近水而居', '宜向北方发展', '适合绿色、青色等木色服饰'];
    } else if (dayMasterElement === '火') {
      xiShen = '木';
      yongShen = '火';
      xiShenDesc = '木能生火，可以生扶日主衰弱的火气';
      yongShenDesc = '火能助火，可以帮助日主增强力量';
      reason = '日主火弱，需要木来生扶，火来助身';
      suggestions = ['适合从事木材、园艺、教育等行业', '可多接触绿色植物', '宜向东方发展', '适合红色、紫色等火色服饰'];
    } else if (dayMasterElement === '土') {
      xiShen = '火';
      yongShen = '土';
      xiShenDesc = '火能生土，可以生扶日主衰弱的土气';
      yongShenDesc = '土能助土，可以帮助日主增强力量';
      reason = '日主土弱，需要火来生扶，土来助身';
      suggestions = ['适合从事能源、电力、文化等行业', '可多用红色物品', '宜向南方发展', '适合黄色、棕色等土色服饰'];
    } else if (dayMasterElement === '金') {
      xiShen = '土';
      yongShen = '金';
      xiShenDesc = '土能生金，可以生扶日主衰弱的金气';
      yongShenDesc = '金能助金，可以帮助日主增强力量';
      reason = '日主金弱，需要土来生扶，金来助身';
      suggestions = ['适合从事房地产、建筑、矿产等行业', '可佩戴玉石', '宜向中央发展', '适合白色、金色等金色服饰'];
    } else if (dayMasterElement === '水') {
      xiShen = '金';
      yongShen = '水';
      xiShenDesc = '金能生水，可以生扶日主衰弱的水气';
      yongShenDesc = '水能助水，可以帮助日主增强力量';
      reason = '日主水弱，需要金来生扶，水来助身';
      suggestions = ['适合从事金融、金属、机械等行业', '可佩戴金属饰品', '宜向西方发展', '适合黑色、蓝色等水色服饰'];
    }
  } else {
    // 中和状态
    xiShen = '调和';
    yongShen = '平衡';
    xiShenDesc = '日主中和，五行相对平衡';
    yongShenDesc = '保持现状，注重调和';
    reason = '日主力量适中，五行相对平衡，不需要特别补救';
    suggestions = ['保持现状，注重生活平衡', '全面发展，不偏不倚', '根据流年调整策略', '注重身心健康'];
  }
  
  return {
    xiShen,
    yongShen,
    xiShenDesc,
    yongShenDesc,
    reason,
    suggestions
  };
}

// ============================================
// 黄历相关内容
// ============================================

// 建除十二神
export const JIANCHU: Record<string, JianChuInfo> = {
  '建': {
    name: '建',
    meaning: '建立、开始',
    nature: '吉',
    yi: ['出行', '上任', '嫁娶', '奠基', '开业', '签约'],
    ji: ['安葬', '动土', '开仓'],
    desc: '建日宜建立新事业，开始新计划。此日做事容易成功，适合开创性工作。'
  },
  '除': {
    name: '除',
    meaning: '清除、整理',
    nature: '吉',
    yi: ['清洁', '整理', '治病', '驱邪', '安葬', '拆卸'],
    ji: ['嫁娶', '开业', '签约'],
    desc: '除日宜清除旧事物，整理环境。此日适合清理、整顿、治病等。'
  },
  '满': {
    name: '满',
    meaning: '圆满、充实',
    nature: '平',
    yi: ['祭祀', '祈福', '纳财', '收藏', '储备'],
    ji: ['开业', '动土', '安葬'],
    desc: '满日宜充实、储备，不宜开启新事业。此日适合祭祀、祈福、收藏。'
  },
  '平': {
    name: '平',
    meaning: '平稳、平和',
    nature: '平',
    yi: ['祭祀', '祈福', '修造', '安床', '出行'],
    ji: ['开业', '嫁娶', '动土'],
    desc: '平日平稳，宜日常事务，不宜重大事项。此日适合平稳度过。'
  },
  '定': {
    name: '定',
    meaning: '安定、确定',
    nature: '吉',
    yi: ['安床', '嫁娶', '纳采', '订婚', '签约', '定居'],
    ji: ['出行', '动土', '诉讼'],
    desc: '定日宜安定、确定，适合固定、稳定的事项。此日适合嫁娶、签约等。'
  },
  '执': {
    name: '执',
    meaning: '执行、固执',
    nature: '平',
    yi: ['捕捉', '狩猎', '追债', '执行', '坚守'],
    ji: ['嫁娶', '开业', '出行'],
    desc: '执日宜执行、坚持，但也容易固执。此日适合执行计划，但不宜新开始。'
  },
  '破': {
    name: '破',
    meaning: '破坏、破损',
    nature: '凶',
    yi: ['拆除', '治病', '驱邪', '破旧立新', '改革'],
    ji: ['嫁娶', '开业', '签约', '出行', '安葬'],
    desc: '破日宜破坏旧事物，不宜新开始。此日适合拆除、治病、改革。'
  },
  '危': {
    name: '危',
    meaning: '危险、危机',
    nature: '凶',
    yi: ['祈福', '祭祀', '安床', '静养'],
    ji: ['出行', '动土', '开业', '嫁娶'],
    desc: '危日有危险，宜静不宜动。此日适合静养、祈福，不宜外出冒险。'
  },
  '成': {
    name: '成',
    meaning: '成就、完成',
    nature: '吉',
    yi: ['开业', '嫁娶', '签约', '出行', '求学', '考试'],
    ji: ['诉讼', '安葬'],
    desc: '成日宜成就事业，完成计划。此日做事容易成功，适合各种吉利事项。'
  },
  '收': {
    name: '收',
    meaning: '收获、收藏',
    nature: '吉',
    yi: ['纳财', '收藏', '储备', '收购', '嫁娶'],
    ji: ['开业', '动土', '安葬', '出行'],
    desc: '收日宜收获、收藏，不宜新开始。此日适合收尾、收藏、储备。'
  },
  '开': {
    name: '开',
    meaning: '开启、开放',
    nature: '吉',
    yi: ['开业', '出行', '动土', '嫁娶', '入学', '求医'],
    ji: ['安葬', '捕捉'],
    desc: '开日宜开启新事业，开放心胸。此日适合各种新的开始，是黄道吉日。'
  },
  '闭': {
    name: '闭',
    meaning: '关闭、结束',
    nature: '平',
    yi: ['安葬', '收藏', '静养', '结束', '收尾'],
    ji: ['开业', '出行', '嫁娶', '动土'],
    desc: '闭日宜结束、关闭，不宜新开始。此日适合收尾、安葬、静养。'
  }
};

// 二十八宿
export const XIUS: Record<string, XiuInfo> = {
  '角': { name: '角', animal: '蛟', direction: '东方青龙', nature: '吉', fortune: '主吉祥，宜婚姻、祭祀', desc: '角宿为东方青龙第一宿，主吉祥，宜婚姻、祭祀、祈福等事。' },
  '亢': { name: '亢', animal: '龙', direction: '东方青龙', nature: '凶', fortune: '主灾祸，宜静不宜动', desc: '亢宿为东方青龙第二宿，主灾祸，宜静不宜动，不利出行。' },
  '氐': { name: '氐', animal: '貉', direction: '东方青龙', nature: '凶', fortune: '主疾病，宜求医治病', desc: '氐宿为东方青龙第三宿，主疾病，宜求医治病，不利嫁娶。' },
  '房': { name: '房', animal: '兔', direction: '东方青龙', nature: '吉', fortune: '主富贵，宜嫁娶、开业', desc: '房宿为东方青龙第四宿，主富贵，宜嫁娶、开业、祭祀。' },
  '心': { name: '心', animal: '狐', direction: '东方青龙', nature: '凶', fortune: '主忧患，宜祈福消灾', desc: '心宿为东方青龙第五宿，主忧患，宜祈福消灾，不利出行。' },
  '尾': { name: '尾', animal: '虎', direction: '东方青龙', nature: '吉', fortune: '主吉祥，宜嫁娶、祭祀', desc: '尾宿为东方青龙第六宿，主吉祥，宜嫁娶、祭祀、祈福。' },
  '箕': { name: '箕', animal: '豹', direction: '东方青龙', nature: '吉', fortune: '主福禄，宜纳财、收藏', desc: '箕宿为东方青龙第七宿，主福禄，宜纳财、收藏、嫁娶。' },
  '斗': { name: '斗', animal: '獬', direction: '北方玄武', nature: '吉', fortune: '主权势，宜上任、考试', desc: '斗宿为北方玄武第一宿，主权势，宜上任、考试、求学。' },
  '牛': { name: '牛', animal: '牛', direction: '北方玄武', nature: '凶', fortune: '主灾祸，宜静养', desc: '牛宿为北方玄武第二宿，主灾祸，宜静养，不利动土。' },
  '女': { name: '女', animal: '蝠', direction: '北方玄武', nature: '平', fortune: '主平常，宜日常事务', desc: '女宿为北方玄武第三宿，主平常，宜日常事务，不宜大事。' },
  '虚': { name: '虚', animal: '鼠', direction: '北方玄武', nature: '凶', fortune: '主空虚，宜静养', desc: '虚宿为北方玄武第四宿，主空虚，宜静养，不利开业。' },
  '危': { name: '危', animal: '燕', direction: '北方玄武', nature: '凶', fortune: '主危险，宜谨慎', desc: '危宿为北方玄武第五宿，主危险，宜谨慎，不利出行。' },
  '室': { name: '室', animal: '猪', direction: '北方玄武', nature: '吉', fortune: '主富贵，宜嫁娶、置业', desc: '室宿为北方玄武第六宿，主富贵，宜嫁娶、置业、祭祀。' },
  '壁': { name: '壁', animal: '貐', direction: '北方玄武', nature: '吉', fortune: '主吉祥，宜修造、祭祀', desc: '壁宿为北方玄武第七宿，主吉祥，宜修造、祭祀、祈福。' },
  '奎': { name: '奎', animal: '狼', direction: '西方白虎', nature: '凶', fortune: '主灾祸，宜静养', desc: '奎宿为西方白虎第一宿，主灾祸，宜静养，不利出行。' },
  '娄': { name: '娄', animal: '狗', direction: '西方白虎', nature: '吉', fortune: '主吉祥，宜祭祀、祈福', desc: '娄宿为西方白虎第二宿，主吉祥，宜祭祀、祈福、嫁娶。' },
  '胃': { name: '胃', animal: '雉', direction: '西方白虎', nature: '吉', fortune: '主丰收，宜纳财、收藏', desc: '胃宿为西方白虎第三宿，主丰收，宜纳财、收藏、储备。' },
  '昴': { name: '昴', animal: '鸡', direction: '西方白虎', nature: '凶', fortune: '主疾病，宜求医', desc: '昴宿为西方白虎第四宿，主疾病，宜求医治病，不利嫁娶。' },
  '毕': { name: '毕', animal: '鸟', direction: '西方白虎', nature: '吉', fortune: '主吉祥，宜嫁娶、开业', desc: '毕宿为西方白虎第五宿，主吉祥，宜嫁娶、开业、祭祀。' },
  '觜': { name: '觜', animal: '猴', direction: '西方白虎', nature: '平', fortune: '主平常，宜日常事务', desc: '觜宿为西方白虎第六宿，主平常，宜日常事务。' },
  '参': { name: '参', animal: '猿', direction: '西方白虎', nature: '吉', fortune: '主吉祥，宜祭祀、祈福', desc: '参宿为西方白虎第七宿，主吉祥，宜祭祀、祈福、出行。' },
  '井': { name: '井', animal: '犴', direction: '南方朱雀', nature: '吉', fortune: '主富贵，宜上任、开业', desc: '井宿为南方朱雀第一宿，主富贵，宜上任、开业、祭祀。' },
  '鬼': { name: '鬼', animal: '羊', direction: '南方朱雀', nature: '凶', fortune: '主灾祸，宜祈福消灾', desc: '鬼宿为南方朱雀第二宿，主灾祸，宜祈福消灾，不利出行。' },
  '柳': { name: '柳', animal: '獐', direction: '南方朱雀', nature: '凶', fortune: '主疾病，宜求医', desc: '柳宿为南方朱雀第三宿，主疾病，宜求医，不利嫁娶。' },
  '星': { name: '星', animal: '马', direction: '南方朱雀', nature: '凶', fortune: '主忧患，宜静养', desc: '星宿为南方朱雀第四宿，主忧患，宜静养，不利动土。' },
  '张': { name: '张', animal: '鹿', direction: '南方朱雀', nature: '吉', fortune: '主吉祥，宜嫁娶、祭祀', desc: '张宿为南方朱雀第五宿，主吉祥，宜嫁娶、祭祀、祈福。' },
  '翼': { name: '翼', animal: '蛇', direction: '南方朱雀', nature: '平', fortune: '主平常，宜日常事务', desc: '翼宿为南方朱雀第六宿，主平常，宜日常事务。' },
  '轸': { name: '轸', animal: '蚓', direction: '南方朱雀', nature: '吉', fortune: '主吉祥，宜出行、祭祀', desc: '轸宿为南方朱雀第七宿，主吉祥，宜出行、祭祀、祈福。' }
};

// 彭祖百忌
export const PENGZU: Record<string, string[]> = {
  '甲': ['甲不开仓财物耗散', '甲日不宜开仓，否则财物会耗散'],
  '乙': ['乙不栽植千株不长', '乙日不宜种植，否则植物难以生长'],
  '丙': ['丙不修灶必见灾殃', '丙日不宜修灶，否则会有灾祸'],
  '丁': ['丁不剃头头必生疮', '丁日不宜剃头，否则头部会生疮'],
  '戊': ['戊不受田田主不祥', '戊日不宜接受田地，否则田地主人会不祥'],
  '己': ['己不破券二比并亡', '己日不宜撕毁契约，否则双方都会受损'],
  '庚': ['庚不经络织机虚张', '庚日不宜纺织，否则织机会空转'],
  '辛': ['辛不合酱主人不尝', '辛日不宜制作酱料，否则主人不会品尝'],
  '壬': ['壬不泱水更难提防', '壬日不宜治水，否则更难提防水患'],
  '癸': ['癸不词讼理弱敌强', '癸日不宜诉讼，否则理由薄弱敌不过对方'],
  '子': ['子不问卜自惹祸殃', '子日不宜占卜，否则会自惹祸殃'],
  '丑': ['丑不冠带主不还乡', '丑日不宜穿戴整齐外出，否则主人不会还乡'],
  '寅': ['寅不祭祀神鬼不尝', '寅日不宜祭祀，神鬼不会品尝祭品'],
  '卯': ['卯不穿井水泉不香', '卯日不宜挖井，否则泉水不会甘甜'],
  '辰': ['辰不哭泣必主重丧', '辰日不宜哭泣，否则会有重丧'],
  '巳': ['巳不远行财物伏藏', '巳日不宜远行，财物需要隐藏'],
  '午': ['午不苫盖屋主更张', '午日不宜盖屋顶，房屋主人会更换'],
  '未': ['未不服药毒气入肠', '未日不宜服药，否则毒气会入肠'],
  '申': ['申不安床鬼祟入房', '申日不宜安床，鬼祟会进入房间'],
  '酉': ['酉不宴客醉坐颠狂', '酉日不宜宴请客人，否则会醉得发狂'],
  '戌': ['戌不吃犬作怪上床', '戌日不宜吃狗肉，否则会作怪上床'],
  '亥': ['亥不嫁娶不利新郎', '亥日不宜嫁娶，对新郎不利']
};

// 时辰黄历信息
export function getShiChenHuangLi(dayGan: string): ShiChenInfo[] {
  return [
    { name: '子时', start: '23:00', end: '01:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '甲' : dayGan === '乙' || dayGan === '庚' ? '丙' : dayGan === '丙' || dayGan === '辛' ? '戊' : dayGan === '丁' || dayGan === '壬' ? '庚' : '壬'}子`, animal: '鼠', yi: ['安床', '祈福', '求财'], ji: ['出行', '动土'] },
    { name: '丑时', start: '01:00', end: '03:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '乙' : dayGan === '乙' || dayGan === '庚' ? '丁' : dayGan === '丙' || dayGan === '辛' ? '己' : dayGan === '丁' || dayGan === '壬' ? '辛' : '癸'}丑`, animal: '牛', yi: ['祭祀', '祈福'], ji: ['出行', '嫁娶'] },
    { name: '寅时', start: '03:00', end: '05:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '丙' : dayGan === '乙' || dayGan === '庚' ? '戊' : dayGan === '丙' || dayGan === '辛' ? '庚' : dayGan === '丁' || dayGan === '壬' ? '壬' : '甲'}寅`, animal: '虎', yi: ['出行', '求财'], ji: ['祭祀', '祈福'] },
    { name: '卯时', start: '05:00', end: '07:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '丁' : dayGan === '乙' || dayGan === '庚' ? '己' : dayGan === '丙' || dayGan === '辛' ? '辛' : dayGan === '丁' || dayGan === '壬' ? '癸' : '乙'}卯`, animal: '兔', yi: ['嫁娶', '出行'], ji: ['动土', '安葬'] },
    { name: '辰时', start: '07:00', end: '09:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '戊' : dayGan === '乙' || dayGan === '庚' ? '庚' : dayGan === '丙' || dayGan === '辛' ? '壬' : dayGan === '丁' || dayGan === '壬' ? '甲' : '丙'}辰`, animal: '龙', yi: ['求财', '交易'], ji: ['安床', '入宅'] },
    { name: '巳时', start: '09:00', end: '11:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '己' : dayGan === '乙' || dayGan === '庚' ? '辛' : dayGan === '丙' || dayGan === '辛' ? '癸' : dayGan === '丁' || dayGan === '壬' ? '乙' : '丁'}巳`, animal: '蛇', yi: ['求学', '考试'], ji: ['出行', '嫁娶'] },
    { name: '午时', start: '11:00', end: '13:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '庚' : dayGan === '乙' || dayGan === '庚' ? '壬' : dayGan === '丙' || dayGan === '辛' ? '甲' : dayGan === '丁' || dayGan === '壬' ? '丙' : '戊'}午`, animal: '马', yi: ['祈福', '求医'], ji: ['动土', '安葬'] },
    { name: '未时', start: '13:00', end: '15:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '辛' : dayGan === '乙' || dayGan === '庚' ? '癸' : dayGan === '丙' || dayGan === '辛' ? '乙' : dayGan === '丁' || dayGan === '壬' ? '丁' : '己'}未`, animal: '羊', yi: ['求财', '纳财'], ji: ['嫁娶', '出行'] },
    { name: '申时', start: '15:00', end: '17:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '壬' : dayGan === '乙' || dayGan === '庚' ? '甲' : dayGan === '丙' || dayGan === '辛' ? '丙' : dayGan === '丁' || dayGan === '壬' ? '戊' : '庚'}申`, animal: '猴', yi: ['出行', '求学'], ji: ['安床', '入宅'] },
    { name: '酉时', start: '17:00', end: '19:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '癸' : dayGan === '乙' || dayGan === '庚' ? '乙' : dayGan === '丙' || dayGan === '辛' ? '丁' : dayGan === '丁' || dayGan === '壬' ? '己' : '辛'}酉`, animal: '鸡', yi: ['嫁娶', '祭祀'], ji: ['动土', '安葬'] },
    { name: '戌时', start: '19:00', end: '21:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '甲' : dayGan === '乙' || dayGan === '庚' ? '丙' : dayGan === '丙' || dayGan === '辛' ? '戊' : dayGan === '丁' || dayGan === '壬' ? '庚' : '壬'}戌`, animal: '狗', yi: ['祈福', '静养'], ji: ['出行', '求财'] },
    { name: '亥时', start: '21:00', end: '23:00', ganZhi: `${dayGan === '甲' || dayGan === '己' ? '乙' : dayGan === '乙' || dayGan === '庚' ? '丁' : dayGan === '丙' || dayGan === '辛' ? '己' : dayGan === '丁' || dayGan === '壬' ? '辛' : '癸'}亥`, animal: '猪', yi: ['安床', '休息'], ji: ['嫁娶', '出行'] }
  ];
}

// 获取建除十二神
export function getJianChu(dayZhi: string, monthZhi: string): string {
  const jianChuOrder = ['建', '除', '满', '平', '定', '执', '破', '危', '成', '收', '开', '闭'];
  const zhiOrder = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
  
  const monthIndex = zhiOrder.indexOf(monthZhi);
  const dayIndex = zhiOrder.indexOf(dayZhi);
  
  if (monthIndex === -1 || dayIndex === -1) return '平';
  
  const offset = (dayIndex - monthIndex + 12) % 12;
  return jianChuOrder[offset];
}

// 获取二十八宿
export function getXiu(dayZhi: string, dayGan: string): string {
  const xiuOrder = ['角', '亢', '氐', '房', '心', '尾', '箕', '斗', '牛', '女', '虚', '危', '室', '壁', '奎', '娄', '胃', '昴', '毕', '觜', '参', '井', '鬼', '柳', '星', '张', '翼', '轸'];
  const zhiOrder = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];
  const ganOrder = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
  
  const zhiIndex = zhiOrder.indexOf(dayZhi);
  const ganIndex = ganOrder.indexOf(dayGan);
  
  if (zhiIndex === -1 || ganIndex === -1) return '角';
  
  const offset = (zhiIndex + ganIndex * 2) % 28;
  return xiuOrder[offset];
}

// 获取彭祖百忌
export function getPengZu(dayGan: string, dayZhi: string): string[] {
  const pengZuList: string[] = [];
  
  if (PENGZU[dayGan]) {
    pengZuList.push(PENGZU[dayGan][0]);
  }
  
  if (PENGZU[dayZhi]) {
    pengZuList.push(PENGZU[dayZhi][0]);
  }
  
  return pengZuList;
}

// 获取每日宜忌（简化版）
export function getYiJi(jianChu: string, xiu: string): { yi: string[], ji: string[] } {
  const yi: string[] = [];
  const ji: string[] = [];
  
  // 根据建除十二神
  const jianChuInfo = JIANCHU[jianChu];
  if (jianChuInfo) {
    yi.push(...(jianChuInfo.yi || []));
    ji.push(...(jianChuInfo.ji || []));
  }
  
  // 根据二十八宿
  const xiuInfo = XIUS[xiu];
  if (xiuInfo) {
    if (xiuInfo.nature === '吉') {
      yi.push('祭祀', '祈福', '嫁娶');
    } else if (xiuInfo.nature === '凶') {
      ji.push('出行', '动土', '嫁娶');
    }
  }
  
  // 去重
  return {
    yi: [...new Set(yi)].slice(0, 6),
    ji: [...new Set(ji)].slice(0, 6)
  };
}

// 导出合并后的知识库
export const KNOWLEDGE_BASE_ENHANCED = {
  TIANGAN: TIANGAN_DETAIL,
  DIZHI: DIZHI_DETAIL,
  NAYIN_DETAIL,
  SHISHEN: SHISHEN_DETAIL,
  GEJU: GEJU_DETAIL,
  DAY_MASTER: DAYMASTER_DETAIL,
  CHANGSHENG,
  SHENSHA,
  JIANCHU,
  XIUS,
  PENGZU,
  getChangShengStatus,
  getShenShaList,
  analyzeXiYongShen,
  getShiChenHuangLi,
  getJianChu,
  getXiu,
  getPengZu,
  getYiJi
};
